import axiosClient from './axiosClient';

export interface Department {
  id: number;
  name: string;
  company_id: number;
  head_user_id: number;
  created_at: string;
}

export interface CreateDepartmentPayload {
  name: string;
  company_id: number;
  head_user_id?: number | null;
}

export interface UpdateDepartmentPayload {
  name?: string;
  head_user_id?: number | null;
}

export interface GetDepartmentsParams {
  company_id?: number;
  skip?: number;
  limit?: number;
}

// Get all departments with optional filtering
export const getDepartments = async (
  params?: GetDepartmentsParams
): Promise<Department[]> => {
  const response = await axiosClient.get('/departments/', {
    params: {
      skip: params?.skip || 0,
      limit: params?.limit || 100,
      company_id: params?.company_id
    }
  });
  return response.data;
};

// Get department by ID
export const getDepartmentById = async (
  departmentId: number
): Promise<Department> => {
  const response = await axiosClient.get(`/departments/${departmentId}`);
  return response.data;
};

// Create new department
export const createDepartment = async (
  departmentData: CreateDepartmentPayload
): Promise<Department> => {
  const response = await axiosClient.post('/departments/', departmentData);
  return response.data;
};

// Create department for all companies (bulk creation)
export const createBulkDepartmentAllCompanies = async (departmentData: {
  name: string;
  head_user_id?: number | null;
}): Promise<Department[]> => {
  const response = await axiosClient.post<Department[]>(
    '/departments/bulk/all-companies',
    departmentData
  );
  return response.data;
};

// Update department
export const updateDepartment = async (
  departmentId: number,
  departmentData: UpdateDepartmentPayload
): Promise<Department> => {
  const response = await axiosClient.put(
    `/departments/${departmentId}`,
    departmentData
  );
  return response.data;
};

// Delete department
export const deleteDepartment = async (
  departmentId: number
): Promise<string> => {
  const response = await axiosClient.delete(`/departments/${departmentId}`);
  return response.data;
};

// Get departments by company ID
export const getCompanyDepartments = async (
  companyId: number
): Promise<Department[]> => {
  return getDepartments({ company_id: companyId });
};
